export enum TAB {
    OVERLAYS = 'overlays',
    SURVEYS = 'surveys'
}
